<template>
    <div>{{title}}</div>
</template>

<script>
export default {
    name: 'statistics-header',
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>